import classNames from 'classnames'

const DownArrow = ({ className }: { className?: string }) => {
  return (
    <svg
      className={classNames(className)}
      viewBox="0 0 5 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.665527 17.1102V0.730225H1.94353V13.8522C2.57353 13.2942 3.54553 12.7002 4.82353 12.1242V13.1502C3.34753 14.4102 2.26753 15.7422 1.56553 17.1102H0.665527Z"
        fill="currentColor"
      />
    </svg>
  )
}

DownArrow.displayName = 'DownArrow'

export default DownArrow
